import { Controller } from "@hotwired/stimulus";

export default class VideoAmbientController extends Controller {
  static targets = ["video", "canvas"];

  connect() {
    this.videoTarget.addEventListener("loadeddata", () => {
      this.resize();
      this.drawFrame();
    });
    this.ctx = this.canvasTarget.getContext("2d");
    this.frameSkip = 0;

    this.resize = this.resize.bind(this);

    this.videoTarget.pause();
    this.videoTarget.currentTime = 0;

    this.element.addEventListener("mouseenter", this.play);
    this.element.addEventListener("mouseleave", this.stop);

    globalThis.addEventListener("resize", this.resize);
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.play);
    this.element.removeEventListener("mouseleave", this.stop);
    globalThis.removeEventListener("resize", this.resize);
  }

  play = () => {
    const video = this.videoTarget;

    this.resize();

    video.play().then(() => {
      this.draw();
    }).catch(() => {
    });
  };

  stop = () => {
    const video = this.videoTarget;
    video.pause();
    // video.currentTime = 0

    this.drawFrame();
  };

  resize() {
    const video = this.videoTarget;
    const canvas = this.canvasTarget;

    canvas.width = video.videoWidth || 300;
    canvas.height = video.videoHeight || 300;
    this.drawFrame();
  }

  draw = () => {
    const video = this.videoTarget;

    if (video.paused || video.ended) return;

    this.frameSkip++;
    if (this.frameSkip % 2 === 0) {
      this.ctx.drawImage(
        video,
        0,
        0,
        this.canvasTarget.width,
        this.canvasTarget.height
      );
    }

    requestAnimationFrame(this.draw);
  };

  drawFrame() {
    this.ctx.drawImage(
      this.videoTarget,
      0,
      0,
      this.canvasTarget.width,
      this.canvasTarget.height
    );
  }
}
